import { PayloadAction, SimpleAction } from 'interfaces/action'
import { createPayloadAction, createAction } from 'helpers/actionsHelpers'
import { AdditionalInfoHeader } from 'interfaces/ajax/base'

export const FLUSH_DATE_UPDATE = 'FLUSH_DATE_UPDATE' as const
export const flushDateUpdateActionCreator =
  (payload: AdditionalInfoHeader): PayloadAction<typeof FLUSH_DATE_UPDATE, AdditionalInfoHeader> =>
    createPayloadAction(FLUSH_DATE_UPDATE, payload)
type FlushDateUpdate = ReturnType<typeof flushDateUpdateActionCreator>

export const SETUP_FLUSH_DATE = 'SETUP_FLUSH_DATE' as const
export const setupFlushDateActionCreator =
  (): SimpleAction<typeof SETUP_FLUSH_DATE> =>
    createAction(SETUP_FLUSH_DATE)
type SetupFlushDate = ReturnType<typeof setupFlushDateActionCreator>

type ConfirmUpdatePopupPayload = {
  isShown: boolean
}
export const CONFIRM_UPDATE_POPUP = 'CONFIRM_UPDATE_POPUP' as const
export const confirmUpdatePopupActionCreator =
  (payload: ConfirmUpdatePopupPayload): PayloadAction<typeof CONFIRM_UPDATE_POPUP, ConfirmUpdatePopupPayload> =>
    createPayloadAction(CONFIRM_UPDATE_POPUP, payload)
type ConfirmUpdatePopup = ReturnType<typeof confirmUpdatePopupActionCreator>

type Action =
  | FlushDateUpdate
  | SetupFlushDate
  | ConfirmUpdatePopup

export default Action
